import { formatPhoneNumber } from 'react-phone-number-input'
import { isEmpty } from 'remeda'

import { getDefaultPhoneNumber } from '../../utils/client-helpers'
import { CopyButton } from '../../components/ui/buttons/copy-button'

import type { LoyaltyData } from '../loyalty.schema'

function NewCustomerInfo({
  checkInMethod,
  client,
}: {
  checkInMethod?: {
    email: string | null
    phone: string | null
  }
  client: Extract<LoyaltyData, { loyaltyType: 'manual' }>['client']
}) {
  const phoneNumber = checkInMethod?.phone
    ? formatPhoneNumber(checkInMethod.phone)
    : client.phoneNumbers.length > 0
    ? formatPhoneNumber(
        getDefaultPhoneNumber(client.phoneNumbers)?.e164 ??
          client.phoneNumbers[0].phoneNumber
      )
    : null

  const email = checkInMethod?.email ? checkInMethod.email : client.email

  return (
    <div className="bg-ion-color-step-100 p-4">
      <h2 className="text-center">New Customer Info</h2>
      <div className="grid grid-cols-6 gap-x-6 gap-y-1">
        {client.firstName ? (
          <div className="col-span-full">
            <CustomerInfo label="First Name" value={client.firstName} />
          </div>
        ) : null}
        {client.lastName ? (
          <div className="col-span-full">
            <CustomerInfo label="Last Name" value={client.lastName} />
          </div>
        ) : null}

        {phoneNumber ? (
          <div className="col-span-full">
            <CustomerInfo label="Phone Number" value={phoneNumber} />
          </div>
        ) : null}

        {email ? (
          <div className="col-span-full">
            <CustomerInfo label="Email" value={email} />
          </div>
        ) : null}

        {client.street1 ? (
          <div className="col-span-full">
            <CustomerInfo label="Street address" value={client.street1} />
          </div>
        ) : null}
        {client.street2 ? (
          <div className="col-span-full">
            <CustomerInfo label="Apt" value={client.street2} />
          </div>
        ) : null}

        {client.city ? (
          <div className="col-span-full">
            <CustomerInfo label="City" value={client.city} />
          </div>
        ) : null}

        {client.state ? (
          <div className="col-span-full">
            <CustomerInfo label="State / Province" value={client.state} />
          </div>
        ) : null}

        {client.zip ? (
          <div className="col-span-full">
            <CustomerInfo label="ZIP / Postal code" value={client.zip} />
          </div>
        ) : null}

        {!client.anniversaryObject ||
        isEmpty(client.anniversaryObject) ? null : (
          <>
            {client.anniversaryObject.month ? (
              <div className="col-span-full">
                <CustomerInfo
                  label="Anniversary Month"
                  value={`${client.anniversaryObject.month + 1}`}
                />
              </div>
            ) : null}
            {client.anniversaryObject.day ? (
              <div className="col-span-full">
                <CustomerInfo
                  label="Anniversary Day"
                  value={`${client.anniversaryObject.day}`}
                />
              </div>
            ) : null}
            {client.anniversaryObject.year ? (
              <div className="col-span-full">
                <CustomerInfo
                  label="Anniversary Year"
                  value={`${client.anniversaryObject.year}`}
                />
              </div>
            ) : null}
          </>
        )}

        {!client.dobObject || isEmpty(client.dobObject) ? null : (
          <>
            {client.dobObject.month ? (
              <div className="col-span-full">
                <CustomerInfo
                  label="Birthday Month"
                  value={`${client.dobObject.month + 1}`}
                />
              </div>
            ) : null}
            {client.dobObject.day ? (
              <div className="col-span-full">
                <CustomerInfo
                  label="Birthday Day"
                  value={`${client.dobObject.day}`}
                />
              </div>
            ) : null}
            {client.dobObject.year ? (
              <div className="col-span-full">
                <CustomerInfo
                  label="Birthday Year"
                  value={`${client.dobObject.year}`}
                />
              </div>
            ) : null}
          </>
        )}
      </div>
    </div>
  )
}

function CustomerInfo({ value, label }: { value: string; label: string }) {
  return (
    <div className="flex justify-between">
      <p className="text-ion-color-secondary text-lg">
        <span className="font-semibold">{label}: </span>
        <span className="inline-flex items-center justify-between">
          {value}
        </span>
      </p>
      <CopyButton clipboard={value} />
    </div>
  )
}

export { NewCustomerInfo }
